import './css/index.scss';
import Tooltip from './directives/tooltip-directive.js';

export default Tooltip;
